import type {
  CompanyAdminCreateInput,
  CompanyDetail,
  CompanyMapResponse,
  CompanyNearby,
  CompanyProfileInput,
  CompanyPublic,
  CompanyRegisterInput,
} from "@app/shared";
import { api, qs } from "../../lib/api";

interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export interface CompanyFilter {
  area?: string;
  industryCode?: string;
  q?: string;
  page?: number;
}

export interface RadiusFilter {
  latitude: number;
  longitude: number;
  radiusKm: number;
  area?: string;
  industryCode?: string;
  q?: string;
  page?: number;
}

export const companiesApi = {
  listPublic: (f: CompanyFilter) =>
    api.get<Paged<CompanyPublic>>(`/companies/public${qs({ ...f })}`),
  getPublic: (id: string) => api.get<CompanyPublic>(`/companies/public/${id}`),
  mapPins: () => api.get<CompanyMapResponse>("/companies/public/map"),
  nearby: (f: RadiusFilter) =>
    api.get<Paged<CompanyNearby>>(`/companies/public/nearby${qs({ ...f })}`),
  register: (input: CompanyRegisterInput) => api.post<{ id: string }>("/companies/register", input),

  search: (f: CompanyFilter) => api.get<Paged<CompanyDetail>>(`/companies${qs({ ...f })}`),
  getDetail: (id: string) => api.get<CompanyDetail>(`/companies/${id}`),
  updateProfile: (id: string, input: CompanyProfileInput) =>
    api.put<CompanyDetail>(`/companies/${id}`, input),
  adminCreate: (input: CompanyAdminCreateInput) =>
    api.post<CompanyDetail>("/companies/admin", input),
};
